import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthClientConfig, AuthHttpInterceptor, AuthService, AuthState } from "@auth0/auth0-angular";
import { Auth0Client } from "@auth0/auth0-spa-js";
import { IConfigService } from "@Config";
import { FeatureToggle } from "@Enums";
import { FeatureManagerService } from "@Services";
import { get } from "lodash";
import { Observable } from "rxjs";

@Injectable()
export class AuthHttpInterceptorExtended  implements HttpInterceptor {
    constructor(public configService: IConfigService, public featureService: FeatureManagerService, public auth0Interceptor: AuthHttpInterceptor) {
        
    }
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (req.url.indexOf('.gtlic.com') > 0) {
            return  next.handle(req);
        }
        else {
            const customParams = localStorage.getItem('customAttributes');

            if (customParams !== null && customParams !== ''){
                const params = new URLSearchParams(customParams);
                const httpParam = this.getParams(params, req);

                const modifiedReq = req.clone({
                    params: httpParam,
                });

                return this.auth0Interceptor.intercept(modifiedReq, next);
            }else{
                return this.auth0Interceptor.intercept(req, next);
            }

        }
    }

    getParams(params: URLSearchParams, req: HttpRequest<any>) : HttpParams {
        if (!this.featureService.getByName(FeatureToggle.GlobalQueryStringEncodeParameters).enabled){
            return this.getParamsLegacy(params, req);
        }

        const queryParams: any = {};

        const excludedQueryParams = this.configService.getExcludedQueryParams();

        params.forEach(function(value, key) {
            if (excludedQueryParams.indexOf(key) < 0)
                queryParams[key] =  value;
        });

        req.params.keys().forEach(function(key) {
            if (excludedQueryParams.indexOf(key) < 0)
                queryParams[key] = req.params.get(key);
        });
        const paramString = JSON.stringify(queryParams);

        let encodedParams = new HttpParams();
        encodedParams = encodedParams.append('customAttributes', btoa(paramString));
        return encodedParams;
    }

    getParamsLegacy(params: URLSearchParams, req: HttpRequest<any>) : HttpParams {
        let httpParam = new HttpParams();

        params.forEach(function(value, key) {
            if (key !== 'connection' && key !== 'redirectTo')
                httpParam = httpParam.append(key, value);
        });

        req.params.keys().forEach(function(key) {
            if (key !== 'connection' && key !== 'redirectTo')
                httpParam = httpParam.append(key, req.params.get(key));
        });

        return httpParam;
    }
}
